import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = {
  key: 0,
  class: "pl-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_CompanyEdition = _resolveComponent("CompanyEdition")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_DeclarationForm = _resolveComponent("DeclarationForm")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AuditDeleteAuditCheckResultDialog = _resolveComponent("AuditDeleteAuditCheckResultDialog")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.options.length)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        "grid-list-md": "",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "1",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_back, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "11" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "1" }),
                      _createVNode(_component_v_col, { cols: "10" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "d-flex justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.options.length && _ctx.options[2].value === true)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            disabled: _ctx.closedPeriod || _ctx.validated,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => {
                            _ctx.createRows();
                            _ctx.miscellaneousOperationDialog = true;
                        }),
                            size: "small"
                          }, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createTextVNode(" OD ")
                            ])),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_tooltip, {
                        location: "bottom",
                        text: _ctx.documentManagerTooltip
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true)),
                              size: "x-small",
                              icon: "$oss-upload",
                              class: "mx-1",
                              disabled: !_ctx.auditCheckResultId
                            }, null, 8, ["disabled"])
                          ], 16)
                        ]),
                        _: 1
                      }, 8, ["text"]),
                      _createVNode(_component_v_tooltip, {
                        location: "bottom",
                        text: "Message"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                          }, props, {
                            size: "x-small",
                            icon: "$oss-chat",
                            class: "mx-1"
                          }), null, 16)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.upsertAuditCheckResult())),
                        size: "small",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createTextVNode(" Enregistrer ")
                        ])),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        disabled: 
                            _ctx.formValid || _ctx.closedPeriod || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateFunction())),
                        "data-cy": "AuditCheckManual-valid",
                        size: "small",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      (_ctx.isEnableReview)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[38] || (_cache[38] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                            _createVNode(_component_v_icon, {
                              disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                              size: "small",
                              icon: "$fa-thumbs-up",
                              color: "primary",
                              class: "mx-1",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.upsertAuditCheckResult('REVIEW');
                            })
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_v_icon, {
                              disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                              size: "small",
                              icon: "$fa-thumbs-down",
                              color: "primary",
                              class: "mx-1",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.upsertAuditCheckResult('REVIEW');
                            })
                            }, null, 8, ["disabled"]),
                            _cache[39] || (_cache[39] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_prev, _mergeProps(props, {
                            disabled: !_ctx.previousControl,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                          }), null, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_next, _mergeProps(props, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                            disabled: !_ctx.nextControl
                          }), null, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                        ]),
                        _: 1
                      }),
                      _cache[46] || (_cache[46] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                            class: "mx-1",
                            color: "secondary"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { nav: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.displayActivityDialog = true))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                      _createTextVNode("$oss-activity")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                                      _createTextVNode("Afficher l'activité")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (!_ctx.showDeleteAcrBtnIfRecovery)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    location: "bottom"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ "no-gutters": "" }, props), [
                                        _createVNode(_component_v_list_item, {
                                          "no-gutters": "",
                                          disabled: ""
                                        }, {
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "small" }, {
                                              default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                _createTextVNode(" $oss-trash ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                _createTextVNode(" Supprimer le contrôle ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.showDeleteAcrBtnTooltipMessage), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    "no-gutters": "",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteAuditCheckResultDialog = true))
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                                          _createTextVNode("$oss-trash")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                                          _createTextVNode(" Supprimer le contrôle ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.loading || _ctx.dataLoading)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 0,
                  elevation: "0",
                  style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          class: "mr-3"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (!_ctx.accountingPeriod)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "d-flex flex-column justify-center align-center mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "mr-2 mb-1",
                        size: "large"
                      }, {
                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createTextVNode(" $oss-warning ")
                        ])),
                        _: 1
                      }),
                      _cache[48] || (_cache[48] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "d-flex flex-column justify-center align-center mb-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              class: "mr-2 mb-1",
                              size: "large"
                            }, {
                              default: _withCtx(() => _cache[49] || (_cache[49] = [
                                _createTextVNode(" $oss-warning ")
                              ])),
                              _: 1
                            }),
                            _cache[50] || (_cache[50] = _createElementVNode("h3", null, "Période clôturée", -1))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.acKey === '3Nai3ztgXhvmIS5wnQHnY1T')
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 1,
                          elevation: "0",
                          style: {"background-color":"white","border-radius":"25px"},
                          class: "pa-6 mt-8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "5",
                                  class: "ma-auto"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                                        _createElementVNode("h5", { class: "pl-4" }, "Données du dossier", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center px-0 justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                            _ctx.showCompanyEdition
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showCompanyEdition = !_ctx.showCompanyEdition)),
                                              style: {"width":"40px"},
                                              class: "d-inline px-2"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CompanyEdition, { mode: 'auditReport' })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.showCompanyEdition]
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.dataLoading)
                      ? (_openBlock(), _createBlock(_component_DeclarationForm, {
                          key: 2,
                          modelValue: _ctx.form,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form) = $event)),
                          auditForm: _ctx.form,
                          auditCheckResult: _ctx.fields,
                          "hide-header": true,
                          readonly: _ctx.validated || _ctx.closedPeriod,
                          ref: "taxForm",
                          onValidUpdate: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateFormValid($event)))
                        }, null, 8, ["modelValue", "auditForm", "auditCheckResult", "readonly"]))
                      : _createCommentVNode("", true),
                    (_ctx.accountableAccounts.length)
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 3,
                          elevation: "0",
                          style: {"background-color":"white","border-radius":"25px"},
                          class: "pa-6 mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  class: "ma-auto"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "2" }, {
                                              default: _withCtx(() => [
                                                (_ctx.accountableAccounts.length)
                                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_4, " Extrait du grand livre "))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_col, { cols: "4" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: _ctx.glAccountingPeriod,
                                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.glAccountingPeriod) = $event)),
                                                  items: _ctx.accountingPeriodsList,
                                                  label: "Exercice",
                                                  disabled: 
                                                !_ctx.generalLedgerExpand ||
                                                !_ctx.accountingPeriodsList.length ||
                                                _ctx.accountingPeriodsList.length === 1
                                            ,
                                                  "hide-details": "",
                                                  inset: "",
                                                  outlined: "",
                                                  density: "compact",
                                                  "item-title": "text"
                                                }, null, 8, ["modelValue", "items", "disabled"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_col, { cols: "4" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_combobox_filled, {
                                                  modelValue: _ctx.glAccountableAccountsRoot,
                                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.glAccountableAccountsRoot) = $event)),
                                                  label: "Racines comptes",
                                                  multiple: "",
                                                  outlined: "",
                                                  "hide-details": "",
                                                  dense: "",
                                                  chips: "",
                                                  "deletable-chips": "",
                                                  "item-disabled": "",
                                                  disabled: 
                                                !_ctx.generalLedgerExpand ||
                                                !_ctx.accountingPeriodsList.length ||
                                                _ctx.accountingPeriodsList.length === 1
                                            ,
                                                  clearable: ""
                                                }, null, 8, ["modelValue", "disabled"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_col, { cols: "1" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_switch, {
                                                  modelValue: _ctx.showNm1,
                                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showNm1) = $event)),
                                                  label: "N-1",
                                                  "hide-details": "",
                                                  disabled: 
                                                !_ctx.generalLedgerExpand ||
                                                !_ctx.accountingPeriodsList.length ||
                                                _ctx.accountingPeriodsList.length === 1
                                            ,
                                                  class: "pl-2 mt-0"
                                                }, null, 8, ["modelValue", "disabled"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center px-0 justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                            _ctx.generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand)),
                                              style: {"width":"40px"},
                                              class: "d-inline px-2"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_v_card_text, {
                              transition: "expand",
                              style: {"padding-bottom":"150px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_GeneralLedger, {
                                          ref: "generalLedger",
                                          companyId: _ctx.companyId,
                                          accountingPeriodId: _ctx.glAccountingPeriod,
                                          accountableAccountFilter: _ctx.glAccountableAccountsRoot,
                                          hideOptions: _ctx.hideOptions,
                                          inThirdParty: _ctx.showThirdParty,
                                          onThirdPartyChanged: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showThirdParty = !_ctx.showThirdParty)),
                                          inNm1: _ctx.showNm1,
                                          onNm1Changed: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showNm1 = !_ctx.showNm1)),
                                          onQueryDone: _ctx.fetchTotals,
                                          enableAuditedAccountableAccounts: 
                                        _ctx.glAccountingPeriod === _ctx.accountingPeriodId
                                    
                                        }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "hideOptions", "inThirdParty", "inNm1", "onQueryDone", "enableAuditedAccountableAccounts"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.generalLedgerExpand]
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && !_ctx.dataLoading)
                      ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                          key: 4,
                          connectedDocuments: _ctx.connectedDocuments,
                          companyId: _ctx.companyId,
                          acKey: _ctx.acKey,
                          auditCheckResult: _ctx.auditCheckResult || {},
                          accountingPeriodId: _ctx.accountingPeriodId || undefined,
                          onUnlinkedDocument: _cache[21] || (_cache[21] = ($event: any) => (_ctx.unlinkDocument($event))),
                          onShowLinkedDocument: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showLinkedDocument($event)))
                        }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && !_ctx.dataLoading)
                      ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                          key: 5,
                          results: _ctx.results,
                          companyId: _ctx.companyId
                        }, null, 8, ["results", "companyId"]))
                      : _createCommentVNode("", true),
                    (_ctx.options.length && _ctx.options[1]?.value === true)
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 6,
                          elevation: "0",
                          style: {"background-color":"white","border-radius":"25px"},
                          class: "pa-6 mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "5",
                                  class: "ma-auto"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                                        _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center px-0 justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                            _ctx.commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.commentExpand = !_ctx.commentExpand)),
                                              style: {"width":"40px"},
                                              class: "d-inline px-2"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.commentExpand)
                              ? (_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 0,
                                  transition: "expand",
                                  style: {"padding-bottom":"150px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "pt-6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_textarea, {
                                              modelValue: _ctx.comment,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.comment) = $event)),
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              "auto-grow": "",
                                              style: {"height":"auto","border":"1px #ededed solid"},
                                              outlined: ""
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.options.length && _ctx.options[0]?.value === true)
                      ? (_openBlock(), _createBlock(_component_v_card, {
                          key: 7,
                          elevation: "0",
                          style: {"background-color":"white","border-radius":"25px"},
                          class: "pa-6 mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "5",
                                  class: "ma-auto"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                                        _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center px-0 justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                              style: {"width":"40px"},
                                              class: "d-inline px-2"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.shortCommentExpand)
                              ? (_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 0,
                                  transition: "expand",
                                  style: {"padding-bottom":"150px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "pt-6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_textarea, {
                                              modelValue: _ctx.shortComment,
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.shortComment) = $event)),
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              "auto-grow": "",
                                              style: {"height":"auto","border":"1px #ededed solid"},
                                              outlined: ""
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_oss_dialog, {
                      modelValue: _ctx.miscellaneousOperationDialog,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                      actions: _ctx.actionsMiscellaneousOperation,
                      "min-width": "90vw"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.miscellaneousOperationDialog)
                          ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                              key: 0,
                              companyId: _ctx.companyId,
                              prefilledRows: _ctx.miscellanousOperationData,
                              acKey: _ctx.acKey,
                              actions: _ctx.actionsMiscellaneousOperation,
                              auditCheckResult: _ctx.auditCheckResult,
                              accountingPeriodId: _ctx.accountingPeriodId,
                              onUpsert: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onOdUpserted($event)))
                            }, null, 8, ["companyId", "prefilledRows", "acKey", "actions", "auditCheckResult", "accountingPeriodId"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "actions"]),
                    (_ctx.deleteAuditCheckResultDialog)
                      ? (_openBlock(), _createBlock(_component_AuditDeleteAuditCheckResultDialog, {
                          key: 8,
                          modelValue: _ctx.deleteAuditCheckResultDialog,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.deleteAuditCheckResultDialog) = $event)),
                          auditCheckResultId: _ctx.auditCheckResultId,
                          onClosed: _cache[30] || (_cache[30] = ($event: any) => {
                            _ctx.deleteAuditCheckResultLoading = false;
                            _ctx.deleteAuditCheckResultDialog = false;
                        }),
                          onDeletedAcr: _ctx.deleteAcrDone
                        }, null, 8, ["modelValue", "auditCheckResultId", "onDeletedAcr"]))
                      : _createCommentVNode("", true),
                    (_ctx.openChat)
                      ? (_openBlock(), _createBlock(_component_Chat, {
                          key: 9,
                          auditCheckAccountingPeriodKey: _ctx.chatId,
                          chatTitle: 'Chat'
                        }, null, 8, ["auditCheckAccountingPeriodKey"]))
                      : _createCommentVNode("", true),
                    (_ctx.dialogAuditCheckDocumentsManager)
                      ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                          key: 10,
                          modelValue: _ctx.dialogAuditCheckDocumentsManager,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                          disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                          companyId: _ctx.companyId,
                          documentToDisplay: _ctx.documentToDisplay,
                          connectedDocuments: _ctx.connectedDocuments || [],
                          acKey: _ctx.acKey,
                          auditCheckResult: _ctx.auditCheckResult || {},
                          accountingPeriodId: _ctx.accountingPeriodId || undefined,
                          alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                          onUpsertedAuditCheckResult: _ctx.upsertedACR,
                          onResetDialogData: _cache[32] || (_cache[32] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                        }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                      : _createCommentVNode("", true),
                    (_ctx.displayActivityDialog)
                      ? (_openBlock(), _createBlock(_component_oss_dialog, {
                          key: 11,
                          modelValue: _ctx.displayActivityDialog,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                          title: "Activité",
                          "valid-title": "Fermer",
                          onValid: _cache[34] || (_cache[34] = ($event: any) => (_ctx.displayActivityDialog = false)),
                          onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.displayActivityDialog = false)),
                          "min-width": "60vw"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_UsersActivitiesHistory, {
                              auditCheckKey: _ctx.acKey,
                              accountingPeriodId: _ctx.accountingPeriodId
                            }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ], 64))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}